const P = ({text, c, id}) => <p id={id} className={c}>{text}</p>

export default P